<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :height="height || tableHeight - 3"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      keep-source
      row-key
      size="small"
      show-footer
      :footer-method="footerMethod"
      class="sample-material-table"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex align-items-stretch">
          <div class="side-frame" v-if="buttonFlag && !disabled"></div>
          <div class="d-flex align-items-center">
            <span
              style="font-size: 14px; color: #606266"
              v-if="buttonFlag && !disabled"
            >
              {{ $l('form_label_accessories_composition') || '辅料构成' }}
            </span>
            <el-divider
              direction="vertical"
              v-if="buttonFlag && !disabled"
            ></el-divider>

            <b-button
              v-if="!disabled"
              size="sm"
              class="mr-2"
              variant="outline-success"
              @click="openSampleMaterialDialog({ type: 'add' })"
            >
              {{ $l('form_label_add_accessories') || '新增辅料' }}
            </b-button>

            <b-button
              v-if="!disabled && !buttonFlag"
              size="sm"
              class="mr-2"
              variant="outline-success"
              @click="synchronousPrice()"
            >
              {{ $l('INDEX.form_label_synchronous_price') || '同步价格' }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:opt1>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px; cursor:pointer"
          @click.native="onImagePreview(row)"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:materialNoInfo="{ row }">
        <span>{{ row.materialNo }} </span>
        <br />
        <span
          >{{ row.mainMaterialCategoryName }} /
          {{ row.detailMaterialCategoryName }}</span
        >
      </template>
      <template v-slot:materialNameInfo="{ row }">
        <span>{{ row.materialName }} </span>
        <br />
        <span>{{ row.materialNameEn }}</span>
      </template>
      <template v-slot:qtyUnitInfo="{ row }">
        <span>{{ row.v_qtyUnit || row.qtyUnit || '--' }}</span>
      </template>
      <template v-slot:price="{ row }">
        <span
          >{{ row.price }} / {{ row.v_qtyUnit ? row.v_qtyUnit : '--' }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openSampleMaterialDialog({ type: 'edit', data: row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.sampleSetMaterialCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listImage"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>

    <SampleAccessoryMaterialDialog
      :disabled="sampleMaterialDialogOptions.disabled"
      :visible.sync="sampleMaterialDialogOptions.visible"
      :title="sampleMaterialDialogOptions.title"
      :formData.sync="sampleMaterialDialogOptions.formData"
      :productLine="productLine"
      :categoryCode="categoryCode"
      @reload="loadData()"
    />
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Sortable from 'sortablejs'
import TableAutoHeight from '@/mixins/table-auto-height'
import { format, add } from '@/libs/util.number.js'
import SampleAccessoryMaterialDialog from './components/detail/dialog.vue'
import tableColumns from './table-columns.js'

export default {
  name: 'sample-set-accessory-material',
  components: { SampleAccessoryMaterialDialog },
  mixins: [EditLoading, TableAutoHeight],
  props: {
    disabled: { type: Boolean, default: false },
    buttonFlag: { type: Boolean, default: false },
    sampleSetCode: { type: String, default: '' },
    productLine: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.loadData(),
        },
        zoom: true,
        custom: true,
      },
      tableData: [],
      listImage: [],
      sampleMaterialDialogOptions: {
        disabled: false,
        visible: false,
        title: '',
        formData: {},
      },
    }
  },
  watch: {
    sampleSetCode: {
      handler() {
        this.loadData()
      },
      immediate: true,
    },
    disabled(val) {
      if (val && this.sortable) {
        this.sortable.destroy()
        this.sortable = null
        return
      }
      this.initRowDrop()
    },
  },
  computed: {
    tableColumns() {
      return tableColumns(this, this.disabled)
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const { tableData } = this.$refs.table.getTableData()
      if (!tableData) return 0
      const totalColumnValues = tableData.reduce((result, next) => {
        totalColumnFields.forEach((field) => {
          result[field] = add(result[field], next[field])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((field) => [field, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((column) => {
          if (!column.isTotalColumn) return ''
          const val = totalColumnValues[column.field]
          return val ? format(val) : '0'
        })
      result[0] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  mounted() {
    this.initRowDrop()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  },
  methods: {
    loadData() {
      this.getData(this.sampleSetCode).then((res) => {
        this.tableData = res
      })
    },
    async getData(sampleSetCode) {
      if (!sampleSetCode) return Promise.resolve([])

      return await this.$api
        .sampleSetMaterialListApi({
          sampleSetCode,
          materialType: 'M',
        })
        .then((res) => Promise.resolve(res.body.data))
    },
    getRowImageList(row) {
      const imageList = Array.isArray(row.imageList) ? row.imageList : []
      const urls = imageList
        .map(
          (image) =>
            image.displayImageUrl ||
            image.originImageUrl ||
            image.thumbImageUrl
        )
        .filter(Boolean)

      if (!urls.length && row.defaultImageUrl) {
        urls.push(row.defaultImageUrl)
      }

      return urls.filter(Boolean)
    },
    onImagePreview(row) {
      this.listImage = this.getRowImageList(row)
      if (!this.listImage.length) return

      this.$nextTick(() => {
        const viewer = this.$el.querySelector('.imagesViewer').$viewer
        viewer.update()
        viewer.view(0)
        viewer.show()
      })
    },
    del(sampleSetMaterialCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.submitDel(sampleSetMaterialCode).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.loadData()
        })
      })
    },
    async submitDel(sampleSetMaterialCode) {
      return await this.$api.sampleSetMaterialDelApi({ sampleSetMaterialCode })
    },
    initRowDrop() {
      if (this.disabled || this.buttonFlag) return
      this.$nextTick(() => {
        const xTable = this.$refs.table
        const tbody =
          xTable &&
          xTable.$el &&
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody')
        if (!tbody) return

        if (this.sortable) {
          this.sortable.destroy()
          this.sortable = null
        }

        this.sortable = Sortable.create(tbody, {
          handle: '.drag-btn',
          onEnd: ({ newIndex, oldIndex }) => {
            if (newIndex == oldIndex) return
            const tableData = [...this.tableData]
            let listMaterial = []
            if (newIndex > oldIndex) {
              for (let i = oldIndex + 1; i <= newIndex; i++) {
                const sortOrder = tableData[i].sortOrder - 1
                const sampleSetMaterialCode =
                  tableData[i].sampleSetMaterialCode
                listMaterial.push({ sortOrder, sampleSetMaterialCode })
              }
            } else {
              for (let i = oldIndex - 1; i >= newIndex; i--) {
                const sortOrder = tableData[i].sortOrder + 1
                const sampleSetMaterialCode =
                  tableData[i].sampleSetMaterialCode
                listMaterial.push({ sortOrder, sampleSetMaterialCode })
              }
            }
            listMaterial.push({
              sortOrder: tableData[newIndex].sortOrder,
              sampleSetMaterialCode:
                tableData[oldIndex].sampleSetMaterialCode,
            })
            this.updateSort(listMaterial)
          },
        })
      })
    },
    openSampleMaterialDialog({ type, data = {} }) {
      const titles = {
        add: this.$l('dialog_title_sample_accessories_add') || '添加辅料信息',
        edit: this.$l('dialog_title_sample_accessories_edit') || '编辑辅料信息',
        detail:
          this.$l('dialog_title_sample_accessories_detail') || '辅料信息详情',
      }
      this.sampleMaterialDialogOptions = {
        visible: true,
        disabled: type === 'edit',
        title: titles[type],
        formData: {
          sampleSetCode: this.sampleSetCode,
          productLine: this.productLine,
          categoryCode: this.categoryCode,
          materialType: 'M',
          materialDesc: '',
          materialSpec: '',
          ...data,
        },
      }
    },
    updateSort(listMaterial) {
      if (this.loadingOpen()) return

      this.submitUpdateSort(listMaterial)
        .then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_update_ok') || '修改成功！',
              type: 'success',
            })
            this.loadData()
          } else {
            this.$message.error(
              this.$l('INDEX.tips_update_no') || '修改失败！'
            )
          }
        })
        .catch(() => {
          this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        })
        .finally(() => {
          this.loadingClose()
        })
    },
    async submitUpdateSort(listMaterial) {
      return await this.$api.sampleSetMaterialUpdateSortApi({ listMaterial })
    },
    footerMethod() {
      return this.footerData
    },
    synchronousPrice() {
      this.$api
        .sampleSetMaterialUpdateCostPriceApi({
          sampleSetCode: this.sampleSetCode,
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.sample-material-table .drag-btn {
  cursor: move;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
